/**
 * API de artículos de una lista.
 */

import api from "./axios";

export async function obtenerArticulos(idLista) {
    const { data } = await api.get(`/listas/${idLista}/articulos/`);
    return data;
}

// Puede recibir artículos manuales o comparados (precio/supermercado/origen).
export async function agregarArticulosBatch(idLista, items) {
    const { data } = await api.post(
        `/listas/${idLista}/articulos/batch`,
        {
            items: items.map((it) => ({
                nombre: it.nombre,
                cantidad: it.cantidad,
                unidad: it.unidad,

                // Viene desde el comparador
                precio_unitario: it.precio_unitario ?? null,
                supermercado: it.supermercado ?? null,
                origen: it.origen ?? null,
            })),
        }
    );

    return data;
}

export async function marcarArticuloComprado(idLista, idArticulo, comprado) {
    const { data } = await api.patch(
        `/listas/${idLista}/articulos/${idArticulo}`,
        { comprado }
    );
    return data;
}

export async function eliminarArticulo(idLista, idArticulo) {
    const { data } = await api.delete(
        `/listas/${idLista}/articulos/${idArticulo}`
    );
    return data;
}
